/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MisclassificationGuidelineResource
 */
export interface MisclassificationGuidelineResource {
    /**
     * The unique identifier of the misclassification guideline.
     * @type {string}
     * @memberof MisclassificationGuidelineResource
     */
    misclassificationGuidelineId: string;
    /**
     * The id of the file containing the guidelines.
     * @type {string}
     * @memberof MisclassificationGuidelineResource
     */
    fileId: string;
    /**
     * The name of the file containing the guidelines.
     * @type {string}
     * @memberof MisclassificationGuidelineResource
     */
    fileName: string;
    /**
     * The ISO 3166-1 alpha-2 country codes that the misclassification guideline applies to.
     * @type {Set<string>}
     * @memberof MisclassificationGuidelineResource
     */
    countryCodes: Set<string>;
    /**
     * URL of the file
     * @type {string}
     * @memberof MisclassificationGuidelineResource
     */
    fileUrl: string;
}

/**
 * Check if a given object implements the MisclassificationGuidelineResource interface.
 */
export function instanceOfMisclassificationGuidelineResource(value: object): value is MisclassificationGuidelineResource {
    if (!('misclassificationGuidelineId' in value) || value['misclassificationGuidelineId'] === undefined) return false;
    if (!('fileId' in value) || value['fileId'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('countryCodes' in value) || value['countryCodes'] === undefined) return false;
    if (!('fileUrl' in value) || value['fileUrl'] === undefined) return false;
    return true;
}

export function MisclassificationGuidelineResourceFromJSON(json: any): MisclassificationGuidelineResource {
    return MisclassificationGuidelineResourceFromJSONTyped(json, false);
}

export function MisclassificationGuidelineResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MisclassificationGuidelineResource {
    if (json == null) {
        return json;
    }
    return {
        
        'misclassificationGuidelineId': json['misclassificationGuidelineId'],
        'fileId': json['fileId'],
        'fileName': json['fileName'],
        'countryCodes': json['countryCodes'],
        'fileUrl': json['fileUrl'],
    };
}

export function MisclassificationGuidelineResourceToJSON(value?: MisclassificationGuidelineResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'misclassificationGuidelineId': value['misclassificationGuidelineId'],
        'fileId': value['fileId'],
        'fileName': value['fileName'],
        'countryCodes': Array.from(value['countryCodes'] as Set<any>),
        'fileUrl': value['fileUrl'],
    };
}

